module.exports = __webpack_public_path__ + "img/charts.5dff12a7.svg";